/** Max number of data rows rendered in the preview (a sanity peek, not a data browser). */
export const BASE_XLSX_CSV_PREVIEW_MAX_ROWS = 200;

/** Result of parsing the first N rows of an .xlsx/.csv file for preview. */
export interface BaseXlsxCsvPreview {
  /** First row of the file, used as the table header. */
  headers: string[];
  /** Data rows (header excluded), capped at BASE_XLSX_CSV_PREVIEW_MAX_ROWS. */
  rows: string[][];
  /**
   * True when the file had more rows than the cap, so the table is partial.
   * The true total is intentionally not exposed: for CSV the parser stops early
   * (PapaParse `preview`) and never reads the full count.
   */
  truncated: boolean;
}
